import { Box, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Sidebar from "../../../components/sideNav";
import CallOverview from "./CallOverview";
import AgentAnalysis from "./AgentAnalysis";
import CustomerAnalysis from "./CustomerAnalysis";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInterceptors";
import { useParams } from "react-router-dom";
import QaParameters from "./QaParameters";
import Loader from "../../../components/AnimatedLoader";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import AudioAnalyticsMui from "./Entities";
import ConversionInsight from "./conversionInsight";
import { jwtDecode } from "jwt-decode";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`button-tabpanel-${index}`}
      aria-labelledby={`button-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const AudioIntelligence = () => {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const [value, setValue] = useState(0);
  const [data, setData] = useState({});
  const [overview, setOverview] = useState({});
  const [customerAnalytics, setCustomerAnalytics] = useState({});
  const [agentAnalytics, setAgentAnalytics] = useState({});
  const [qaParameters, setQaParameters] = useState([]);
  const [transcript, setTranscript] = useState([]);
  const [loading, setLoading] = useState(true);
  const [entities, setEntities] = useState([]);
  const [conversionData, setConversionData] = useState({});
  const [customerName, setCustomerName] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [dialerId, setDialerId] = useState('');

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const reportEndpoint = decodedToken?.companyId === "6a6b4ce723abe63bde91abf2"
        ? apiEndPointsConfig?.kiwiInteraction
        : apiEndPointsConfig?.interaction;
      const res = await axiosInstance.get(
        `${reportEndpoint}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setData(res?.data?.data[0]);
      setQaParameters(res?.data?.data[0]?.callAdherence || []);
      setOverview(res?.data?.data[0]?.overallSummary);
      setCustomerAnalytics(res?.data?.data[0]?.customerSummary);
      setAgentAnalytics(res?.data?.data[0]?.agentSummary);
      setTranscript(res?.data?.data[0]?.transcript);
      setLoading(false);
      setEntities(res?.data?.data[0]?.entities)
      setConversionData(res?.data?.data[0]?.conversionInsights)
      setCustomerName(res?.data?.data[0]?.customerName)
      setCreatedAt(res?.data?.data[0]?.createdAt)
      setDialerId(res?.data?.data[0]?.dialerId)
    } catch (error) {
      console.error("Audio analytics fetch error:", error);
      setLoading(false);
    }
  };

  const allowedCompanyIds = [
    "67e560a6ae2e0d3f96b5eb08",
    "67e560a6ae2e0d3f96b5eb09",
    "6992ccc4728c075c4da097b3"
  ];

  const tabLabels = [
    "Overview",
    "QA Parameters",
  ];

  return (
    <>
      {loading ? (
        <ParentWrapper>
          <Loader />
        </ParentWrapper>
      ) : (
        <ParentWrapper>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            {tabLabels?.map((label, index) => (
              <Button
                key={index}
                variant={value === index ? "contained" : "outlined"}
                onClick={() => setValue(index)}
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 550,
                  fontSize: "small",
                  fontFamily: "sans-serif",
                  borderRadius: "10px",
                  bgcolor:
                    value == index
                      ? colorTheme("palette", "primary").value
                      : "",
                }}
              >
                {label}
              </Button>
            ))}
          </Box>

          <CustomTabPanel value={value} index={0}>
            <CallOverview
              overview={overview}
              data={data}
              agentAnalytics={agentAnalytics}
              customerAnalytics={customerAnalytics}
              transcript={transcript}
              setValue={setValue}
            />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <QaParameters qaParameters={qaParameters} Id={id} interactionData={data} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <AudioAnalyticsMui entitiesData={entities} />
          </CustomTabPanel>
          {decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08" && <CustomTabPanel value={value} index={5}>
            <ConversionInsight conversionData={conversionData} customerName={customerName} createdAt={createdAt} dialerId={dialerId} transcript={transcript} />
          </CustomTabPanel>}
        </ParentWrapper>
      )}
    </>
  );
};

export default AudioIntelligence;
